<div class="input-container">
    <div [ngSwitch]="activeInputMenuItem">
        <!-- <div class="input-content" *ngSwitchCase="'Header Layout'">
            <ngx-header-layout></ngx-header-layout>
        </div> -->
        <div class="input-content" *ngSwitchCase="'Sections'">
            <ngx-main-header></ngx-main-header>
            <ngx-top-header></ngx-top-header>
            <ngx-bottom-header></ngx-bottom-header>
        </div>
        <div class="input-content pallette" *ngSwitchCase="'Styling'">
            <div class="content-cell bordered">
                <div class="cell-head"><span class="header-text">What's this</span></div>
                <div class="cell-content text">Color range used for general elements such as backgrounds, buttons and text.You can override this for specific elements.</div>
            </div>
            <div class="content-cell bordered">
                <div class="cell-head"><span class="header-text">Current Values</span></div>
                <div class="cell-content current-values">
                    <div class="value-label">Column width</div>
                    <div class="value">1366px</div>
                </div>
            </div>
            <div class="content-cell">
                <div class="cell-head"><span class="header-text">Options</span></div>
                <div class="cell-content pallette-options">
                    <div *ngFor="let theme of themes" (click)="setTheme(theme)" class="button-wrapper" >
                        <button [style.background-color]="theme.pallette" class="pallette-button"></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="input-container" *ngSwitchCase="'Top Header'">
            <ngx-top-header></ngx-top-header>
            <!-- <div class="content-cell bordered">
                <div class="cell-head"><span class="header-text">What's this</span></div>
                <div class="cell-content text">Color range used for general elements such as backgrounds, buttons and text.You can override this for specific elements.</div>
            </div>
            <div class="content-cell bordered">
                <div class="cell-head"><span class="header-text">Current Values</span></div>
                <div class="cell-content current-values">
                    <div class="value-label">Column width</div>
                    <div class="value">1366px</div>
                </div>
            </div>
            <div class="content-cell">
                <div class="cell-head"><span class="header-text">Options</span></div>
                <div class="cell-content pallette-options">
                    <div *ngFor="let theme of themes" (click)="setTheme(theme)" class="button-wrapper" >
                        <button [style.background-color]="theme.pallette" class="pallette-button"></button>
                    </div>
                </div>
            </div> -->
        </div>
        <div class="input-container" *ngSwitchCase="'Main Header'">
            <ngx-main-header></ngx-main-header>
        </div>
        <div class="input-container" *ngSwitchCase="'Bottom Header'">
            <ngx-bottom-header></ngx-bottom-header>
        </div>
        <div class="input-content" *ngSwitchDefault>
            <nb-tabset (changeTab)="tabChanged($event)">
                <nb-tab tabTitle={{defaultInputMenuItem}}>
                    <ngx-header-layout></ngx-header-layout>
                </nb-tab>
                <nb-tab tabTitle="Sections">
                    <nb-accordion multi kwExpandFirstItem>
                        <nb-accordion-item expanded>
                            <nb-accordion-item-header>Main Header</nb-accordion-item-header>
                            <nb-accordion-item-body class="inner-cell">
                                <ngx-main-header></ngx-main-header>
                            </nb-accordion-item-body>
                        </nb-accordion-item>
                        <nb-accordion-item>
                            <nb-accordion-item-header>Top Header</nb-accordion-item-header>
                            <nb-accordion-item-body class="inner-cell">
                                <ngx-top-header></ngx-top-header>
                            </nb-accordion-item-body>
                        </nb-accordion-item>
                        <nb-accordion-item>
                            <nb-accordion-item-header>Bottom Header</nb-accordion-item-header>
                            <nb-accordion-item-body class="inner-cell">
                                <ngx-bottom-header></ngx-bottom-header>
                            </nb-accordion-item-body>
                        </nb-accordion-item>
                    </nb-accordion>
                    <!-- <ngx-main-header></ngx-main-header>
                    <ngx-top-header></ngx-top-header>
                    <ngx-bottom-header></ngx-bottom-header> -->
                    <!-- <kve-sections-editor></kve-sections-editor> -->
                </nb-tab>
            </nb-tabset>
            
                
            <!-- <div class="content-cell bordered">
                <div class="cell-head"><span class="text">What's this</span></div>
                    <div class="cell-content text">
                        Number of rows in the header. Main header contains logo and tools. Top and bottom rows are optional.
                    </div>
                </div>
            <div class="content-cell bordered">
                <div class="cell-head"><span class="text">Current Values</span></div>
                <div class="cell-content current-values">
                    <div class="value-label">Number of Rows</div>
                    <div class="value">2 : Main and Top</div>
                </div>
                <div class="cell-content current-values">
                    <div class="value-label">Default</div>
                    <div class="value">2 : Main and Top</div>
                </div>
            </div>
            <div class="content-cell">
                <div class="cell-head"><span class="text">Options</span></div>
                <div class="cell-content">
                    <form class="form-inline">
                        <div class="option-element">
                            <nb-radio-group [(ngModel)]="option">
                                <nb-radio class="editor-radio"
                                    *ngFor="let option of options"
                                    [value]="option.value">
                                    {{ option.label }}
                                </nb-radio>
                            </nb-radio-group>
                        </div>
                      </form>
                </div>
            </div> -->
        </div>
    </div>
</div>


